import {fade} from "@material-ui/core/styles";
import {titleColor} from "../constants";

const styles = theme => ({
    root: {
        height: "calc(100% - 70px)",
    },
    elements: {
        overflowX: "hidden",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        paddingTop: "70px",
        backgroundColor: fade(titleColor, 0.1),
    },
    text: {
        display: "flex",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            alignItems: "center",
        },
    },
    textBox: {
        width: "250px",
    },
    title: {
        color: titleColor,
        fontSize: "25px",
        [theme.breakpoints.down("sm")]: {
            alignSelf: "center",
        },
    },
    textField: {
        width: "100%",
        padding: "20px",
        paddingLeft: "20%",
        alignSelf: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            alignSelf: "center",
            paddingLeft: "0px",
        },
    },
    byText: {
        width: "100%",
        padding: "20px",
        paddingRight: "20%",
        alignSelf: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            paddingRight: "0px",
            paddingTop: "0px",
            width: "300px"
        },
    },
    textSide: {
        width: "300px"
    },
    footer: {
        justifySelf: "flex-end",
    },
});

export default styles